/**
 * The content of one of a service's tabs on the Apps tab (every tab but Overview), scoped to that service, with its
 * "Open …" link to the project's full tab. `onOpenFull` is that link (null: no link, the plan hides the tab or there
 * is nowhere to go). `readOnly` (a viewer): the tabs that can write (Git) only read.
 */
import React from 'react';
import PropTypes from 'prop-types';
import ApiTab from './ApiTab';
import CodeTab from './CodeTab';
import ConfigTab from './ConfigTab';
import DataTab from './DataTab';
import GitTab from './GitTab';
import LogsTab from './LogsTab';
import QualityTab from './QualityTab';
import TracesTab from './TracesTab';

const PANELS = { api: ApiTab, code: CodeTab, config: ConfigTab, data: DataTab, git: GitTab, logs: LogsTab, quality: QualityTab, traces: TracesTab };

export default function ServiceTabPanel({ tab, projectId, service, serviceName, sessionId = null, onOpenFull = null, readOnly = false }) {
  const Panel = PANELS[tab];
  if (!Panel) { return null; }
  return <Panel key={`${tab}:${serviceName}`} onOpen={onOpenFull} projectId={projectId} readOnly={readOnly} service={service} serviceName={serviceName} sessionId={sessionId} />;
}

ServiceTabPanel.propTypes = {
  onOpenFull: PropTypes.func,
  projectId: PropTypes.string,
  readOnly: PropTypes.bool,
  service: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  sessionId: PropTypes.string,
  tab: PropTypes.string.isRequired,
};
